import { useI18n } from 'hooks/useI18n';
import { getPublicPath } from 'utils/paths';
import {
  StyledSkillsNoStack,
  StyledSkillsNoStackContent,
  StyledSkillsNoStackImg,
  StyledSkillsNoStackTitle
} from './SkillsNoStack.styled';

const SkillsNoStack = () => {
  const { t } = useI18n('job-offer');

  return (
    <StyledSkillsNoStack>
      <StyledSkillsNoStackImg
        src={getPublicPath('/images/jobOffer/technologies/no-stack.svg')}
        alt={t('skills.noStack')}
      />
      <StyledSkillsNoStackContent>
        <StyledSkillsNoStackTitle>
          {t('skills.noStack')}
        </StyledSkillsNoStackTitle>
        <p>{t('skills.noStackDesc')}</p>
      </StyledSkillsNoStackContent>
    </StyledSkillsNoStack>
  );
};

export default SkillsNoStack;
